const plugin = (editor,options) => {

  console.log('con opts',options);

  var reports = [];
  if (options && options.reports) {
    reports = options.reports;
  }

  editor.Components.addType('wf-user-task-list',{
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'wflist',
    model: {
      defaults: {
        script: function() {
          console.log('do task list start');
          var taskList  = new WorkflowTaskList();
        },
        traits: [
          "title"
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });
  editor.Components.addType('ts-login-dialog',{
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-login-dialog',
    model: {
      defaults: {
        script: function() {
          console.log('do login dialog');
          var logoutBtn = new LoginView();
        }
      }
    }
  });
  editor.DomComponents.addType('ts-logout-btn',{
    isComponent: el => el.id === 'logout',
    model: {
      defaults: {
        script: function() {
          console.log('run logout script',document);
          var logout = new LogoutButton();
        },
        traits: [
          "className",
          "bezeichnung"
        ]
      },
      init() {
        console.log('init logout button');
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle update',this);
        this.view.render();
      },
    }
  });
  editor.DomComponents.addType('ts-data-table', {
    isComponent: el=> el.id == 'tsdatatable',
    model: {
      defaults: {
        script: function() {
          console.log('open table',this);
          new DataTable({ el: this });
        },
        traits: [
          "Tabelle",
          "pageSize",
          "formGroup",
          "openURL"
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle table update',this);
        this.view.render();
      },
    },
  });

  editor.DomComponents.addType('ts-data-save', {
    isComponent: el=> el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-save',
    model: {
      defaults: {
        script: function() {
          new DataTableSaveButton({ el: this });
        },
        traits: [
          "Tabelle",
          "formGroup",
          "bezeichnung",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle table save update',this);
        this.view.render();
      },
    },
  });

  editor.DomComponents.addType('ts-data-new', {
    isComponent: el=> el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-new',
    model: {
      defaults: {
        script: function() {
          new DataTableNewEntry({ el: this });
        },
        traits: [
          "Tabelle",
          "IDColumn",
          "openURL",
          "formGroup",
          "bezeichnung"
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle table save update',this);
        this.view.render();
      },
    },
  });

  editor.DomComponents.addType('ts-data-table-filter', {
    isComponent: el=> el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-table-filter',
    model: {
      defaults: {
        script: function() {
          new DataTableFilter({ el: this });
        },
        traits: [
          "Tabelle",
          "Feld",
          {
            "type":"select",
            "name":"type",
            "options": [
              {"id":"text","name":"Text"},
              {"id":"number","name":"Zahl"},
              {"id":"date","name":"Datum"},
            ]
          }
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    },
  });


  editor.DomComponents.addType('ts-data-url-load', {
    isComponent: el=> el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-url-load',
    model: {
      defaults: {
        script: function() {
          if (!this.attributes || !this.attributes.formgroup) return;
          console.log('got group',this.attributes.formgroup);
          const searchParams = new URLSearchParams(window.location.search);
          var table = searchParams.get('table');
          var idc   = searchParams.get('idc');
          var idv   = searchParams.get('idv');
          var grp   = this.attributes.formgroup.value;

          // check if new entry (empty idv)
          if (!idv || idv==='') {
            clearGroupedParams(grp);
            return;
          }

          console.log('load url',table,idc,idv);
          if (idc && idv && table) {
            var filter = {};
            filter[idc] = idv;
            var url = '/trendshop.proxy.web/rest/tables/data/' + encodeURIComponent(table) + '?start=0&count=10&filter=' + encodeURIComponent(JSON.stringify(filter));
            console.log(url);
            fetch(url).then(resp => resp.json()).then(function(data) {
              console.log('data loaded',data,grp);
              if (data && data.length > 0)
                fillGroupedParams(data[0],grp);
            })
          }
        },
        traits: [
          "formGroup",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle table load update',this);
        this.view.render();
      },
    },
  });

  editor.DomComponents.addType('ts-data-table-pages', {
    isComponent: el=> el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-table-pages',
    model: {
      defaults: {
        script: function() {
          new DataTablePagingButtons({ el: this });
        },
        traits: [
          "Tabelle",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('handle table save update',this);
        this.view.render();
      },
    },
  });

  editor.DomComponents.addType('ts-proc-start', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-proc-start',
    model: {
      defaults: {
        script: function() {
          console.log('open table',this);
          new StartProcessButton({ el: this });
        },
        traits: [
          "classname",
          "bezeichnung",
          "processkey",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-hand-user-list', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-hand-users',
    model: {
      defaults: {
        script: function() {
          console.log('open handuser table',this);
          new HandUserList({ el: this });
        },
        traits: [
          "pageSize",
          "editUserLink",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-hand-user', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-hand-user',
    model: {
      defaults: {
        script: function() {
          console.log('open handuser form',this);
          new HandUserEditor({ el: this });
        },
      },
    }
  });

  editor.DomComponents.addType('ts-hand-user-login', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-hand-user-login',
    model: {
      defaults: {
        script: function() {
          console.log('open hand login',this);
          new HandUserLogin({ el: this });
        }
      },
    }
  });

  editor.DomComponents.addType('ts-hand-user-ef', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-hand-user-ef',
    model: {
      defaults: {
        script: function() {
          console.log('open handuser ef form',this);
          this.widget = new HandUserExtraField({ el: this });
        },
        traits: [
          "fieldname",
          "label"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        console.log('update ef',this.widget);
        this.view.render();
      },
    }
  });


  editor.DomComponents.addType('ts-hand-user-flags', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-hand-user-flags',
    model: {
      defaults: {
        script: function() {
          console.log('set handuser flags');
          new HandUserAcessFlag({ el: this });
        },
        traits: [
          {
            "type":"select",
            "name":"title",
            "options": [
              {"id":"bshopLogin","name":"bShop Login"},
              {"id":"viewallcontacts","name":"Alle Kunden"},
              {"id":"selfprice","name":"Freie Preiseingabe"},
              {"id":"costManager","name":"Kostenstellen Manager"}
            ]
          }
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-article-upload', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-article-upload',
    model: {
      defaults: {
        script: function() {
          var w = new CSVArticleUpload({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
//          console.log('update ef',document.widgets[this.id]);
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-images-upload', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-images-upload',
    model: {
      defaults: {
        script: function() {
          var w = new CSVImagesUpload({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
//          console.log('update ef',document.widgets[this.id]);
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-customer-upload', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-customer-upload',
    model: {
      defaults: {
        script: function() {
          var w = new CSVCustomerUpload({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
//          console.log('update ef',document.widgets[this.id]);
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-smbdata-upload', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-smbdata-upload',
    model: {
      defaults: {
        script: function() {
          var w = new CSVDataUpload({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname",
          "title",
          "dateiname",
          "key"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
//          console.log('update ef',document.widgets[this.id]);
        this.view.render();
      },
    }
  });  

  editor.DomComponents.addType('ts-bflow-exec', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-bflow-exec',
    model: {
      defaults: {
        script: function() {
          var w = new BFlowExecuteButton({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname",
          "flowId",
          "paramsgroup",
          "download"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-sr-send', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-sr-send',
    model: {
      defaults: {
        script: function() {
          var w = new SendServiceRequestButton({ el: this });
        },
        traits: [
          "bezeichnung",
          "classname",
          "paramsgroup",
          "serviceName"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-script-exec', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-script-exec',
    model: {
      defaults: {
        script: function() {
          var w = new ScriptExecuteButton({ el: this });
        },
        traits: [
          "bezeichnung",
          "paramsgroup",
          "script",
          "template"
        ],
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-customer-list', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-customer-table',
    model: {
      defaults: {
        script: function() {
          console.log('open customers table',this);
          new CustomerList({ el: this });
        },
        traits: [
          "pageSize",
          "editCustomerLink",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-article-list', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-article-table',
    model: {
      defaults: {
        script: function() {
          console.log('open article table',this);
          new ArticleList({ el: this });
        },
        traits: [
          "pageSize",
          "editArticleLink",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-article-view', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-article-view',
    model: {
      defaults: {
        script: function() {
          console.log('open article',this);
          new ArticleBaseView({ el: this });
        }
      },
    }
  });

  editor.DomComponents.addType('ts-article-prices', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-article-prices',
    model: {
      defaults: {
        script: function() {
          console.log('open article prices ',this);
          new ArticlePriceList({ el: this });
        }
      },
    }
  });

  editor.DomComponents.addType('ts-customer-view', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-customer-view',
    model: {
      defaults: {
        script: function() {
          console.log('open customer',this);
          new CustomerBaseView({ el: this });
        }
      },
    }
  });

  editor.DomComponents.addType('ts-order-list', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-order-table',
    model: {
      defaults: {
        script: function() {
          console.log('open order table',this);
          new OrderList({ el: this });
        },
        traits: [
          "pageSize",
          "editOrderLink",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-offer-list', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-offer-table',
    model: {
      defaults: {
        script: function() {
          console.log('open offer table',this);
          new OfferList({ el: this });
        },
        traits: [
          "pageSize",
          "editOfferLink",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });
  
  editor.DomComponents.addType('ts-order-view', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-order-view',
    model: {
      defaults: {
        script: function() {
          console.log('open order',this);
          new OrderBaseView({ el: this });
        }
      },
    }
  });

  editor.DomComponents.addType('ts-pdf-catalogs', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-pdf-catalogs',
    model: {
      defaults: {
        script: function() {
          new PDFCatalogList({ el: this });
        },
        traits: [
          "pageSize",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-report-view', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-report-view',
    model: {
      defaults: {
        script: function() {
          console.log('open report view',this);
          new ReportView({ el: this });
        },
        traits: [
          {
            "type":"select",
            "name":"report",
            "options": reports
          },
          "width",
          "height"
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.DomComponents.addType('ts-data-sync-start', {
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'ts-data-sync-start',
    model: {
      defaults: {
        script: function() {
          console.log('open sync',this);
          new DataSyncStartButton({ el: this });
        },
        traits: [
          "classname",
          "bezeichnung",
          "area",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      },
    }
  });

  editor.Blocks.add('wf-user-task-list', {
    id: 'wf-user-task-list',
    label: 'Offene Aufgaben',
    content: '<div name="wflist" id="wf-user-task-list"></div>',
    category: 'Digitale Prozesse',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 384 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"/></svg>'
  });
  editor.Blocks.add('ts-login-dialog',{
    id: 'ts-login-dialog',
    label: 'Login Dialog',
    content: '<div name="ts-login-dialog" id="ts-login-dialog"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"/></svg>'
  });
  editor.Blocks.add('ts-logout-btn', {
    id: 'ts-logout-btn',
    label: 'Abmelden',
    content: '<div id="logout"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"/></svg>'
  });
  editor.Blocks.add('ts-article-upload',{
    id: 'ts-article-upload',
    label: 'Artikel Upload',
    content: '<div name="ts-article-upload"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>'
  });
  editor.Blocks.add('ts-images-upload',{
    id: 'ts-images-upload',
    label: 'Bilder Upload',
    content: '<div name="ts-images-upload"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>'
  });
  editor.Blocks.add('ts-customer-upload',{
    id: 'ts-customer-upload',
    label: 'Kunden Upload',
    content: '<div name="ts-customer-upload"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>'
  });
  editor.Blocks.add('ts-smbdata-upload',{
    id: 'ts-smbdata-upload',
    label: 'SMB Upload',
    content: '<div name="ts-smbdata-upload"></div>',
    category:'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>'
  })
  editor.Blocks.add('ts-data-table',{
    id: 'ts-data-table',
    label: 'Datentabelle',
    content: '<div id="tsdatatable"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"/></svg>'
  });
  editor.Blocks.add('ts-data-table-filter',{
    id: 'ts-data-table-filter',
    label: 'Filter',
    content: '<div name="ts-data-table-filter"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"/></svg>'
  });
  editor.Blocks.add('ts-data-save',{
    id: 'ts-data-save',
    label: 'Daten speichern',
    content: '<div name="ts-data-save"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M433.9 129.9l-83.9-83.9A48 48 0 0 0 316.1 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V163.9a48 48 0 0 0 -14.1-33.9zM224 416c-35.3 0-64-28.7-64-64 0-35.3 28.7-64 64-64s64 28.7 64 64c0 35.3-28.7 64-64 64zm96-304.5V212c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12V108c0-6.6 5.4-12 12-12h228.5c3.2 0 6.2 1.3 8.5 3.5l3.5 3.5A12 12 0 0 1 320 111.5z"/></svg>'
  });
  editor.Blocks.add('ts-data-new',{
    id: 'ts-data-new',
    label: 'Neuer Datensatz',
    content: '<div name="ts-data-new"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"/></svg>'
  });
  editor.Blocks.add('ts-data-url-load',{
    id: 'ts-data-url-load',
    label: 'URL Daten laden',
    content: '<div name="ts-data-url-load"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M572.7 292.1L500.3 416.2A64 64 0 0 1 445 448H45c-18.5 0-30.1-20.1-20.7-36.1l72.4-124.2A64 64 0 0 1 152 256h400c18.5 0 30.1 20.1 20.7 36.1zM152 224h328v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v278l69.1-118.4C86.2 242.3 118 224 152 224z"/></svg>'
  });
  editor.Blocks.add('ts-data-table-pages',{
    id: 'ts-data-table-pages',
    label: 'Paging',
    content: '<div class="btn-toolbar" role="toolbar" name="ts-data-table-pages"><div class="btn-group"><button name="prev" class="btn btn-secondary"><strong>&lt;</strong></button><button name="next" class="btn btn-secondary"><strong>&gt;</strong</button></div></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"/></svg>'
  });
  editor.Blocks.add('ts-report-view',{
    id: 'ts-report-view',
    label: 'Bericht',
    content: '<div name="ts-report-view" class="wrapper"></div>',
    category: 'Daten',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"/></svg>'
  });
  editor.Blocks.add('ts-start-proc', {
    id: 'ts-start-proc',
    label: 'Prozess Start',
    content: '<div name="ts-proc-start"></div>',
    category: 'Digitale Prozesse',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>'
  });
  editor.Blocks.add('ts-hand-user-list', {
    id: 'ts-hand-user-list',
    label: 'Vertreterliste',
    content: '<div name="ts-hand-users"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"/></svg>'
  });
  editor.Blocks.add('ts-hand-user-form', {
    id: 'ts-hand-user',
    label: 'Vertreter Benutzerdaten',
    content: '<div name="ts-hand-user"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/></svg>',
  });
  editor.Blocks.add('ts-hand-user-login', {
    id: 'ts-hand-user-login',
    label: 'Vertreterlogin',
    content: '<div name="ts-hand-user-login"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"/></svg>'
  });
  editor.Blocks.add('ts-hand-user-ef', {
    id: 'ts-hand-user-ef',
    label: 'Vertreter Extrafeld',
    content: '<div name="ts-hand-user-ef"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"/></svg>',
  });
  editor.Blocks.add('ts-hand-user-flags', {
    id: 'ts-hand-user-flags',
    label: 'Vertreter Rechte',
    content: '<div name="ts-hand-user-flags"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"/></svg>',
  });
  editor.Blocks.add('ts-bflow-exec', {
    id: 'ts-bflow-exec',
    label: 'Flow Ausführen',
    content: '<div name="ts-bflow-exec"></div>',
    category: 'Digitale Prozesse',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>'
  });
  editor.Blocks.add('ts-script-exec', {
    id: 'ts-script-exec',
    label: 'Skript Ausführen',
    content: '<div name="ts-script-exec"></div>',
    category: 'Digitale Prozesse',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M48 0C21.5 0 0 21.5 0 48v64c0 8.8 7.2 16 16 16h80V48C96 21.5 74.5 0 48 0zm208 412.6V352h288V96c0-52.9-43.1-96-96-96H111.6C121.7 13.4 128 29.9 128 48v368c0 38.9 34.7 69.7 74.8 63.1C234.2 474 256 444.5 256 412.6zM288 384v32c0 52.9-43.1 96-96 96h336c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16H288z"/></svg>'
  });
  editor.Blocks.add('ts-sr-send', {
    id: 'ts-sr-send',
    label: 'Service Anfrage',
    content: '<div name="ts-sr-send"></div>',
    category: 'Digitale Prozesse',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"/></svg>'
  });
  editor.Blocks.add('ts-article-list', {
    id: 'ts-article-list',
    label: 'Artikeldaten',
    content: '<div name="ts-article-table"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"/></svg>'
  });
  editor.Blocks.add('ts-article-view', {
    id: 'ts-article-view',
    label: 'Artikelstammdaten',
    content: '<div name="ts-article-view"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"/></svg>'
  });  editor.Blocks.add('ts-article-prices', {
    id: 'ts-article-prices',
    label: 'Artikelpreise',
    content: '<div name="ts-article-prices"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.7 413.8c-1.3-6.6-7.8-10.9-14.4-9.4-10.7 2.4-27.4 5.4-45.4 5.4-56.8 0-101.9-34.8-121.5-85.4h113.7a12 12 0 0 0 11.7-9.4l6.4-28.4c1.7-7.5-4-14.6-11.7-14.6H115.2c-1.2-14.3-1.4-28.3 .1-42.2H262a12 12 0 0 0 11.7-9.4l6.5-29.8c1.6-7.5-4.1-14.6-11.7-14.6H130.2c20.6-45 62.7-75 117.6-75 14.5 0 28.6 2.3 37.9 4.1 6.2 1.3 12.3-2.5 14-8.6l12-44.4c1.8-6.7-2.5-13.6-9.3-14.9C290.2 34.9 270.7 32 249.6 32 152.5 32 74 92.3 45.1 176H12c-6.6 0-12 5.4-12 12v29.8c0 6.6 5.4 12 12 12h21.6c-1 13.6-1.2 29.3-.2 42.2H12c-6.6 0-12 5.4-12 12v28.4c0 6.6 5.4 12 12 12h30.1C67.1 414.7 145.3 480 249.6 480c26.3 0 48.6-4.5 61.1-7.8 6.2-1.6 10-7.7 8.8-14l-8.8-44.5z"/></svg>'
  });
  editor.Blocks.add('ts-customer-list', {
    id: 'ts-customer-list',
    label: 'Kundentabelle',
    content: '<div name="ts-customer-table"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"/></svg>'
  });
  editor.Blocks.add('ts-customer-view', {
    id: 'ts-customer-view',
    label: 'Kundenstammdaten',
    content: '<div name="ts-customer-view"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/></svg>'
  });
  editor.Blocks.add('ts-order-list', {
    id: 'ts-order-list',
    label: 'Aufträge',
    content: '<div name="ts-order-table"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"/></svg>'
  });
  editor.Blocks.add('ts-offer-list', {
    id: 'ts-offer-list',
    label: 'Angebote',
    content: '<div name="ts-offer-table"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"/></svg>'
  });
  editor.Blocks.add('ts-order-view', {
    id: 'ts-order-view',
    label: 'Auftragsansicht',
    content: '<div name="ts-order-view"></div>',
    category: 'ERP',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/></svg>'
  });

  editor.Blocks.add('ts-pdf-catalogs', {
    id: 'ts-pdf-catalogs',
    label: 'PDF-Kataloge',
    content: '<div name="ts-pdf-catalogs"></div>',
    category: 'iHand',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1 .1-.2 .1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"/></svg>'
  });

  editor.Blocks.add('ts-data-sync-start',{
    id: 'ts-data-sync-start',
    label: 'ERP Datensyncronisation',
    content: '<div name="ts-data-sync-start"></div>',
    category: 'Connector',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"/></svg>'
  });


}

export default plugin;
